<template>
    <div class="flex-row">
        <div v-if="showCheckbox" class="checkbox-container">
            <v-checkbox
                v-model="model"
                class="rtls-checkbox"
                :indeterminate="indeterminate && !allSelectedInHierarchy"
            />
        </div>
        <div v-if="isPromotion" class="promotion-rag-colour__colour" :class="colorClass" />
        <div v-if="!isPromotion" class="promotion-name">
            {{ params.data.description | toSentenceCase }}
        </div>
        <div v-else class="promotion-name">
            <span v-if="showIcon">
                <icon :icon-name="iconName" />
            </span>
            <span v-else class="icon-placeholder" />
            {{ params.data.description | toSentenceCase }}
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { last } from 'lodash';
import promotionTypes from '@enums/promotion-types';
import { mapState } from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState('subCampaigns', ['selectedForAllocationPromotionIds']),
        model: {
            get() {
                return this.isSelected();
            },
            set(value) {
                this.selectionHandler(value);
            },
        },
        colour() {
            return this.params.data.effectivenessRating;
        },
        colorClass() {
            return `promotion-rag-colour__colour--${this.colour}`;
        },
        showIcon() {
            return (
                this.params.data.promotionType &&
                this.params.data.promotionType !== promotionTypes.standard
            );
        },
        iconName() {
            return this.params.data.promotionType === promotionTypes.split
                ? 'split-promotion-icon'
                : 'attribute-promotion';
        },
        hasValue() {
            return this.params.data.effectivenessRating >= 0;
        },
        indeterminate() {
            if (this.params.data.promotionId) return false;
            const promotionsForHierarchy = this.getPromotionsForHierarchy;
            return (
                !!this.selectedForAllocationPromotionIds.length &&
                promotionsForHierarchy.some(id =>
                    this.selectedForAllocationPromotionIds.includes(id)
                )
            );
        },
        allSelectedInHierarchy() {
            const promotionsForHierarchy = this.getPromotionsForHierarchy;
            return (
                !!this.selectedForAllocationPromotionIds.length &&
                promotionsForHierarchy.every(id =>
                    this.selectedForAllocationPromotionIds.includes(id)
                )
            );
        },
        getPromotionsForHierarchy() {
            const relevantId = last(this.params.data.id.split(':'));
            const promotionsForHierarchy = this.params.promotionsForHierarchy(relevantId);
            return promotionsForHierarchy;
        },
        showCheckbox() {
            return this.params.selectAllSCAP || (!this.params.selectAllSCAP && this.hasValue);
        },
        isPromotion() {
            return this.params.data.promotionId;
        },
    },
    methods: {
        isSelected() {
            if (this.params.data.promotionId) {
                return this.selectedForAllocationPromotionIds.find(
                    id => id === this.params.data.promotionId
                );
            }
            return this.allSelectedInHierarchy;
        },
        selectionHandler(value) {
            if (this.params.data.promotionId) {
                this.params.selection(this.params.data.promotionId, value);
            } else this.params.hierarchySelection(last(this.params.data.id.split(':')), value);
        },
    },
});
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
@import '@style/base/_mixins.scss';

.promotion-rag-colour {
    &__colour {
        height: 1.3rem;
        width: 1.3rem;
        border-radius: 5rem;
        margin-top: 1.4rem;
        background: $promo-product-badge;
        @include promo-rag-colours(background);
    }
}
.flex-row {
    display: flex;
    flex-direction: row !important;
}
.checkbox-container {
    display: flex;
    align-items: center;
    padding: 0 0.2rem;
    margin-right: 0.5rem;
}
.v-input--indeterminate {
    ::v-deep {
        .mdi.mdi-minus-box {
            transition: none !important;
            &::before {
                content: ' ';
                width: 1.5rem;
                height: 1.5rem;
                background: $promo-white;
                border-radius: 0.2rem;
                border: 0.4rem solid $promo-primary-colour;
                transition: none;
            }
        }
    }
}

::v-deep {
    .v-input--checkbox.rtls-checkbox .v-input--selection-controls__input .v-icon {
        width: 1.5rem;
        height: 1.5rem;
    }
}

.promotion-name {
    margin-left: 1rem;
}

.icon-placeholder {
    margin-right: 1.7rem;
}
</style>
